__turbopack_context__.v({
  "aboutMeContainer": "xHRP0q_aboutMeContainer",
  "aboutMeHeading": "xHRP0q_aboutMeHeading",
  "agentBio": "xHRP0q_agentBio",
  "productItem": "xHRP0q_productItem",
  "productName": "xHRP0q_productName",
  "productsContainer": "xHRP0q_productsContainer",
  "productsHeading": "xHRP0q_productsHeading",
  "productsList": "xHRP0q_productsList",
});
